import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LeftTree from "../components/LeftTree.vue";
import { StatisticsServiceProxy } from "@/service-proxies/app-v2/mdc.service-proxies";

const ssp = new StatisticsServiceProxy();
enum RENDER_METHODS {
  Table,
  BarStatic,
}

@Component
class Bar extends Vue {
  @Prop({ default: () => [] }) readonly dataValue: any;
  @Prop({ default: () => [] }) readonly columns: any;
  @Prop({ default: () => [] }) readonly tab: any;
  myChart = null;
  mounted() {
    this.init();
  }

  @Watch("dataValue", { deep: true })
  init() {
    let list = {
      bz: [],
      more: [],
      few: [],
      xLable: [],
      color: "#60ADF5",
      standand: [],
    };
    if (this.tab === "1") {
      this.dataValue.shiftOutputList &&
        this.dataValue.shiftOutputList.map((item) => {
          // list.bz.push(item.capacity);
          let num = item.output - item.capacity;
          list.standand.push(item.capacity);
          if (num > 0) {
            list.more.push(num);
            list.bz.push(item.capacity);
            list.few.push(0);
          } else {
            list.few.push(-num);
            list.bz.push(item.capacity + num);
            list.more.push(0);
          }
          list.xLable.push(`${item.indexName}(${item.productName})`);
          list.color = item.colour;
        });
    } else {
      this.dataValue.deviceOutputList &&
        this.dataValue.deviceOutputList.map((item) => {
          // list.bz.push(item.capacity);
          let num = item.output - item.capacity;
          list.standand.push(item.capacity);
          if (num > 0) {
            list.more.push(num);
            list.bz.push(item.capacity);
            list.few.push(0);
          } else {
            list.few.push(-num);
            list.bz.push(item.capacity + num);
            list.more.push(0);
          }
          list.xLable.push(`${item.deviceName}(${item.productName})`);
          list.color = item.colour;
        });
    }

    let option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: function(params) {
          let html = params[0].name + "<br>";
          for (let i = 0; i < params.length; i++) {
              if (params[i].seriesName==='标准产量') {
                  html += params[i].seriesName + " : " + (list.standand[params[i].dataIndex]) + "<br>";
              }else if(params[i].seriesName==='采集产量高于标准产量数量'){
                if(list.more[params[i].dataIndex]!==0){
                  let num = list.more[params[i].dataIndex]
                  html += params[i].seriesName + " : " + num + "<br>";
                }
              }else if(params[i].seriesName==='采集产量低于标准产量数量'){
                if(list.few[params[i].dataIndex]!==0){
                  let caiji = list.few[params[i].dataIndex]
                  html += params[i].seriesName + " : " + caiji + "<br>";
                }

            }
          }
          return html;
        },
      },
      legend: {
        // data: ['标准产量','采集产量多','采集产量少']
        data: [],
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: list.xLable,
          axisLabel: {
            formatter: function(params) {
              let newStr = params.split("(");
              let newParamsName = newStr[0];
              return newParamsName;
            },
            interval: 0,
            rotate: -35,
          },
        },
      ],
      yAxis: [
        {
          type: "value",
        },
      ],
      series: [
        {
          name: "标准产量",
          type: "bar",
          stack: "产能",
          itemStyle: {
            normal: {
              color: list.color,
            },
          },
          label: {
            normal: {
              show: true,
              position: "top",
              formatter: function(params) {
                let newStr = params.name.split("(");
                let word = newStr[1].substr(0, newStr[1].length - 1)
                let newParamsName =  '{font1|'+word+'}'+'\n'
                return (list.few[params.dataIndex]===-0&&list.more[params.dataIndex]===0)
                  ? newParamsName + list.standand[params.dataIndex] + "/" + list.standand[params.dataIndex]
                  : "";
              },
              rich:{
                font1:{
                  fontWeight:700,
                  fontSize: list.more.length>4?((20-(list.more.length*1)>10)?20-(list.more.length*1):10):20
                }
              },
              textStyle: {
                color: "#000",
                fontSize: list.more.length>4?((20-(list.more.length*1)>10)?20-(list.more.length*1):10):20,
                align:'center'
              },
            },
          },
          data: list.bz,
        },
        {
          name: "采集产量高于标准产量数量",
          type: "bar",
          stack: "产能",
          itemStyle: {
            normal: {
              color: "#4CE043",
            },
          },
          label: {
            normal: {
              show: true,
              position: "top",
              formatter: function(params) {
                let newStr = params.name.split("(");
                let word = newStr[1].substr(0, newStr[1].length - 1)
                let newParamsName =  '{font1|'+word+'}'+'\n'
                return params.value !== 0
                  ? newParamsName + (params.value+list.standand[params.dataIndex]) + "/" + list.standand[params.dataIndex]
                  : "";
              },
              rich:{
                font1:{
                  fontWeight:700,
                  fontSize: list.more.length>4?((20-(list.more.length*1)>10)?20-(list.more.length*1):10):20
                }
              },
              textStyle: {
                color: "#000",
                fontSize: list.more.length>4?((20-(list.more.length*1)>10)?20-(list.more.length*1):10):20,
                align:'center'
              },
            },
          },
          data: list.more,
        },
        {
          name: "采集产量低于标准产量数量",
          type: "bar",
          stack: "产能",
          label: {
            normal: {
              show: true,
              position: "top",
              formatter: function(params) {
                let newStr = params.name.split("(");
                let word = newStr[1].substr(0, newStr[1].length - 1)
                let newParamsName =  '{font1|'+word+'}'+'\n'
                return params.value !== 0
                  ? newParamsName + (list.bz[params.dataIndex]) + "/" + list.standand[params.dataIndex]
                  : "";
              },
              rich:{
                font1:{
                  fontWeight:700,
                  fontSize: list.few.length>4?((20-(list.few.length*1)>10)?20-(list.few.length*1):10):20,

                }
              },
              textStyle: {
                color: "#000",
                fontSize: list.few.length>4?((20-(list.few.length*1)>10)?20-(list.few.length*1):10):20,
                align:'center'
              },
            },
          },
          itemStyle: {
            normal: {
              color: "#EF3C3C",
            },
          },
          data: list.few,
        },
      ],
    };
    var myChart = (this as any).$echarts.init(this.$refs.myChart as any);
    myChart.setOption(option);

    this.myChart = myChart;
  }

  mathDataLength() {
    return (90 / this.dataValue.length).toFixed(2);
  }

  render() {
    return (
      <div>
        <div>
          <span style="color:#1890FF;font-size:16px;margin:0 10px;font-weight:600">
            {this.tab === "1"
              ? this.dataValue.deviceInfo
              : this.dataValue.timeInfo}
          </span>
          <span style="font-weight:600">{this.$t('page_station_comprehensive_chart_name')}</span>
        </div>
        <div ref="myChart" style="height:300px;margin-bottom:20px"></div>
      </div>
    );
  }
}

@Component({
  components: {
    Bar,
  },
})
class BarStatic extends Vue {
  @Prop({ default: () => [] }) readonly data: any;
  @Prop({ default: () => [] }) readonly columns: any;
  @Prop({ default: () => {} }) readonly searchObj: any;
  @Prop({ default: () => {} }) changeTabIndex: any;
  tabKey = "1";
  barData = [];
  dataLoading = false;
  mounted() {
    this.initData();
  }
  @Watch("data", { deep: true })
  initData() {
    this.barData = this.data;
  }
  mout;
  renderBar() {
    return (
      <div>
        {this.barData.map((item) => (
          (this.tabKey==='1'?(item.shiftOutputList.length>0?<Bar dataValue={item} ref="bar" tab={this.tabKey} />:''):(item.deviceOutputList.length>0?<Bar dataValue={item} ref="bar" tab={this.tabKey} />:''))
        ))}
      </div>
    );
  }
  renderDateBar() {
    return (
      <div>
        {this.barData.map((item) => (
          <Bar dataValue={item} ref="bar" tab={this.tabKey} />
        ))}
      </div>
    );
  }
  async tabChange(val) {
    this.dataLoading = true;
    this.tabKey = val;
    this.barData = [];
    this.changeTabIndex(val);
    if (val === "1") {
      const res = await ssp.workStationOutputByDeviceComparation(
        this.searchObj
      );
      this.dataLoading = false;
      this.barData = res;
    } else {
      const res = await ssp.workStationOutputByTimeComparation(this.searchObj);
      this.dataLoading = false;
      this.barData = res;
    }
    this.dataLoading = false;
  }
  render() {
    return (
      <a-tabs default-active-key="1" onChange={this.tabChange}>
        <a-tab-pane key="1" tab={this.$t("page_equipment_barcharts")}>
          {this.dataLoading ? (
            <div style="text-align:center;margin-top:30%">
              <a-spin />
            </div>
          ) : (
            this.renderBar()
          )}
        </a-tab-pane>
        <a-tab-pane key="2" tab={this.$t("page_date_barcharts")}>
          {this.dataLoading ? (
            <div style="text-align:center;margin-top:30%">
              <a-spin />
            </div>
          ) : (
            this.renderBar()
          )}
        </a-tab-pane>
      </a-tabs>
    );
  }
}

@Component({
  components: {
    LeftTree,
    BarStatic,
  },
})
class ProductivityAnalysis extends Vue {
  columns = [];
  operationData = [];
  showType = 1;
  tabIndex = "1";
  loading = false;
  searchValue: any = {};
  tableData = [];
  x = 1000
  @Watch("showType", { deep: true })
  timeSearch() {
    if (this.showType === 0) {
      ssp.workStationOutputByTimeComparation(this.searchValue).then((res) => {
        this.tableData = res;
      });
    }
  }
  render() {
    return (
      <a-layout style="height: 100%">
        <a-layout-sider
          width="360"
          style="background: #fff; min-width:360px; overflow:auto;"
          class="no-fix-sider"
        >
          {this.renderLeftTree()}
        </a-layout-sider>
        <div v-resize={"x"}></div>
        <a-layout-content style={{ height: "100%" }}>
          {this.renderBody()}
        </a-layout-content>
      </a-layout>
    );
  }

  renderLeftTree() {
    return (
      <left-tree
        init={["statistical", "shift", "time", "Tree.vue","product"]}
        onSearch={(value) => this.search(value)}
        onOutPut={() => this.outPut()}
        queryKey="cnfx"
      ></left-tree>
    );
  }

  outPut() {}

  changeTab(val) {
    // console.log(val)
    this.tabIndex = val;
  }

  async search(value) {
    delete value.productivityType;
    this.searchValue = { ...value };
    this.loading = true;
    try {
      if (this.showType === 1) {
        const data = await ssp.workStationOutputByDeviceComparation(value);
        this.operationData = data;
      } else {
        const data = await ssp.workStationOutputByTimeComparation(
          this.searchValue
        );
        this.tableData = data;
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  renderBody() {
    return (
      <blank-view>
        <div
          slot="action"
          style="display: flex; justify-content: space-between;"
        >
          <a-radio-group v-model={this.showType}>
            <a-radio-button value={1}>
              {this.$t("page_operation_statistics_barchart")}
            </a-radio-button>
            <a-radio-button value={0}>
              {this.$t("page_operation_statistics_tablechart")}
            </a-radio-button>
          </a-radio-group>
        </div>
        {this.loading ? (
          <div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;">
            <a-spin />
          </div>
        ) : (
          this.renderContent()
        )}
      </blank-view>
    );
  }

  renderTable() {
    const columns = this.tableData.map((item) => ({
      title: item.timeInfo,
      dataIndex: item.timeInfo,
    }));
    columns.unshift({
      title: this.$t("page_workstation_name"),
      dataIndex: "title",
    });
    this.x = columns.length*160
    let dataSource = [];
    this.tableData.map((item) => {
      if (item.deviceOutputList) {
        item.deviceOutputList.map((Item) => {
          Item.title = Item.deviceName + "(" + Item.productName + ")";
          Item[item.timeInfo] = Item.output;
          dataSource.push(Item);
        });
      }
    });
    return (
      <ml-table
        size="small"
        columns={columns}
        defaultExpandAllRows={true}
        dataSource={dataSource}
        canChangeColWidth={false}
        canFixedHead={true}
        scroll={{x:this.x,y: 750 }}
        isAutoWidth={true}
      ></ml-table>
    );
  }

  renderBarStatic() {
    return (
      <div>
        <BarStatic
          data={this.operationData}
          columns={this.columns}
          searchObj={this.searchValue}
          changeTabIndex={this.changeTab}
        />
      </div>
    );
  }

  renderContent() {
    const renderMethod = `render${RENDER_METHODS[this.showType]}`;
    return this[renderMethod]();
  }
}

export default ProductivityAnalysis;
